var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrinter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8571 37.654C11.8571 36.6875 12.6406 35.904 13.6071 35.904H43.9404C44.9069 35.904 45.6904 36.6875 45.6904 37.654V51.654C45.6904 52.6205 44.9069 53.404 43.9404 53.404H13.6071C12.6406 53.404 11.8571 52.6205 11.8571 51.654V37.654ZM15.3571 39.404V49.904H42.1904V39.404H15.3571Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.69043 23.654C3.69043 22.6875 4.47393 21.904 5.44043 21.904H52.1071C53.0736 21.904 53.8571 22.6875 53.8571 23.654V44.654C53.8571 45.6205 53.0736 46.404 52.1071 46.404H43.9606C42.9941 46.404 42.2106 45.6205 42.2106 44.654V39.404H15.3343V44.654C15.3343 45.6205 14.5508 46.404 13.5843 46.404H5.44043C4.47393 46.404 3.69043 45.6205 3.69043 44.654V23.654ZM7.19043 25.404V42.904H11.8343V37.654C11.8343 36.6875 12.6178 35.904 13.5843 35.904H43.9606C44.9271 35.904 45.7106 36.6875 45.7106 37.654V42.904H50.3571V25.404H7.19043Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6904 4.9873C10.6904 4.02081 11.4739 3.2373 12.4404 3.2373H45.1071C46.0736 3.2373 46.8571 4.02081 46.8571 4.9873V23.654C46.8571 24.6205 46.0736 25.404 45.1071 25.404H12.4404C11.4739 25.404 10.6904 24.6205 10.6904 23.654V4.9873ZM14.1904 6.7373V21.904H43.3571V6.7373H14.1904Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.cf46ede1.svg";
export { ForwardRef as ReactComponent };